// de_pms_personal_dashboard.ts
// Tłumaczenia dla PersonalDashboard.tsx

export const dePmsPersonalDashboard = {

  // ── Powitania ─────────────────────────────────────────────────────────────
  greetings: {
    morning:   "Guten Morgen",
    afternoon: "Guten Tag",
    evening:   "Guten Abend",
  },

  // ── Sekcje widgety ────────────────────────────────────────────────────────
  sections: {
    liveActivity:   "Live-Aktivität",
    housekeepingQueue:"Housekeeping-Warteschlange",
    openIncidents:  "Offene Vorfälle",
    handover:       "Übergabe",
    finance:        "Finanzen",
    activity:       "Aktivität",
    operations:     "Betrieb",
    maintenance:    "Wartung",
    guests:         "Gäste",
  },

  // ── Pasek narzędzi ────────────────────────────────────────────────────────
  toolbar: {
    customize: "Anpassen",
    done:      "Fertig",
    enter:     "Öffnen",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    arrivalToday:           "Anreise heute",
    arrivalsToday:          "Anreisen heute",
    assignedToHousekeeping: "Housekeeping zugewiesen",
    needsCleaning:          "Reinigung erforderlich",
    occupancy:              "Auslastung",
    revenue:                "Umsatz",
    openIssues:             "Offene Probleme",
    noCriticalIssues:       "Keine kritischen Probleme",
    noPickupData:           "Keine Pickup-Daten",
    noRevenueData:          "Keine Umsatzdaten",
    noRevenueHistory:       "Keine Umsatzhistorie",
    noLinkedIncident:       "Kein verknüpfter Vorfall zur Zuweisung",
    noLinkedIncidentResolve:"Kein verknüpfter Vorfall zur Lösung",
  },

  // ── Przekazanie ───────────────────────────────────────────────────────────
  handover: {
    acknowledged: "Übergabe bestätigt",
    noteAdded:    "Übergabenotiz hinzugefügt",
    markedResolved:"Als gelöst markiert",
  },

} as const;

export default dePmsPersonalDashboard;
